<template>
  <div class="container">
  <h1 class="text-center main-title" v-html="$t('title.product')">
      产品<em>中心</em>
      <span>Products</span>
    </h1>
    
    <div class="main-content" v-html="contentInfo.body">
    
    </div>
  </div>

  
</template>

<script>
import axios from 'axios'
import qs from 'qs';
export default {
  name: "pdetail",
   metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      contentInfo:{},
    };
  },
  created(){
  //console.log(this.$route.params.pId);
  //  axios.post('http://www.hzjingbao.cn/api/product',qs.stringify({ id: sessionStorage.getItem("pid") , lang: this.$i18n.locale}),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
  //   .then(res=>{
  //    console.log(res)
  //     console.log(this.contentInfo)
  //     console.log(typeof this.contentInfo)
  //     this.contentInfo = res.data
  //   })
  //   .catch(error=>{
  //     console.log(error)  
  //   })
  if(this.$i18n.locale == 'cn'){
      document.querySelector('meta[name="keywords"]').setAttribute('content', '乳胶粉,可再分散乳胶粉,木胶粉,网洞高分子胶粉,脲醛树脂胶粉,木工胶,脲醛树脂,木工胶粉')
      document.querySelector('meta[name="description"]').setAttribute('content', '公司在原木胶粉、可再分散性乳胶粉、木工胶粉、脲醛树脂胶粉等产品基础上，长期与大专院校、科研单位合作，不断研制开发各类高起点、高品质、安全环保的建材类新产品以满足不断发展、不断更新的各类建筑业产品的需要。')
    }else{
      document.querySelector('meta[name="keywords"]').setAttribute('content', 'Latex powder, redisperse latex powder, wood gum powder, net hole polymer rubber powder, urea formaldehyde resin rubber powder, wood gum, urea formaldehyde resin, carpentry rubber powder')
      document.querySelector('meta[name="description"]').setAttribute('content', 'The company has long cooperated with colleges and universities and scientific research institutes on the basis of products such as log gum powder, dispersible latex powder, carpentry gum powder, and urea-formaldehyde resin gum powder. To develop new building materials products with high starting point, high quality, safety and environmental protection to meet the needs of all types of construction products that are continuously developed and updated.')
    }
  },
  computed:{
      pageName(){
      return this.$t("mteaTitle.product");
    }
  },
  mounted(){
    var pid= this.$route.params.pId;
    sessionStorage.setItem("pid", pid);
    axios.post('http://www.hzjingbao.cn/api/product',qs.stringify({ id: pid , lang: this.$i18n.locale}),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then(res=>{
     // console.log(res)
      this.contentInfo = res.data
    })
    .catch(error=>{
      console.log(error)  
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/pdetail.vue